import React, { FC, useState } from "react";
import { Stack } from "react-bootstrap";
import BSButton from "react-bootstrap/Button";
import { CameraVideoOffFill } from "react-bootstrap-icons";
import { useUnlinkCameraMutation } from "features/api/usersPermissionsManagement/usersPermissionsManagementApiSlice";
import ConfirmationModal from "common/components/ConfirmationModal/ConfirmationModal";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "components/Reports/reportAssets/assets";
import { volunteerData } from "./volunteerTypes";

type Props = {
  volunteer: volunteerData;
};

const UnlinkCameraButton: FC<Props> = ({ volunteer }) => {
  const { t } = useTranslation();
  const [modalShow, setModalShow] = useState(false);
  const [unlinkCamera] = useUnlinkCameraMutation();

  const HandleConfirmUnlink = async () => {
    setModalShow(false);
    const res = await unlinkCamera({
      cameraUuid: volunteer.userApp.cameraUuid,
    }).unwrap();

    if (res) {
      toast.success(SUCCESS_MESSAGE);
    } else toast.error(ERROR_MESSAGE);
  };

  return volunteer.userApp.cameraUuid ? (
    <>
      {modalShow && (
        <ConfirmationModal
          modalShow
          setModalShow={setModalShow}
          title={t("unlinkCamera")}
          contentText={t("unlinkCameraConfirmMessage")}
          onConfirm={HandleConfirmUnlink}
          onCancle={() => setModalShow(false)}
        />
      )}
      <Stack direction="horizontal" gap={0}>
        <div className="button-wrapper">
          <BSButton key={volunteer?.userApp?.cameraUuid} variant="outline">
            <CameraVideoOffFill
              size={20}
              color="primary"
              onClick={() => {
                setModalShow(true);
              }}
            />
          </BSButton>
        </div>
      </Stack>
    </>
  ) : null;
};

export default UnlinkCameraButton;
